<template>
    <layout class="text-white">
        <!--        Page Menu is loaded by the layout-->
        <section-featured-post
            :blog-post="blogPost"
            :show-teaser="true"
            class="mb-12 tablet:mb-10"
        />
        <!--        Container Content Section-->
        <div class="container flex flex-col tablet:flex-row mb-32">
            <!--Post Content & Social Media-->
            <div
                v-if="socialLinks"
                class="social-share tablet:mt-32 tablet:w-2/12 phone:mb-4 phone:mr-32"
            >
                <social-share-post
                    :social-networks="socialLinks.socialNetworks"
                    :social-share-title="socialShareTitle"
                    :post-slug="blogPost.postMeta.slug"
                    :category-slug="blogPost.postCategory.slug"
                />
            </div>
            <!--Post HTML Content-->
            <post-content
                :blog-post-content="blogPost.postContent.content"
                :drop-cap="blogPost.postContent.drop_cap" />
        </div>
        <!--Related Posts-->
        <list-related-posts
            v-if="listRelatedPosts.blogPosts && listRelatedPosts.blogPosts.length > 0"
            :blog-posts="listRelatedPosts.blogPosts"
            :labels="listRelatedPosts.labels" />
        <!-- <section-instagram
            :external-links="$page.externalLinks"
            :section-instagram="sectionInstagram" /> -->
        <!--Footer is loaded by the layout-->
    </layout>
</template>

<script>
import Layout from '@web/components/PageLayout';
import SectionFeaturedPost from '@web/pages/sections/BlogHome/SectionFeaturedPost';
import SocialSharePost from '@web/components/Blog/SocialSharePost';
import PostContent from '@web/pages/sections/BlogPost/PostContent';
import ListRelatedPosts from '@web/components/Blog/ListRelatedPosts';
// import SectionInstagram from '@web/pages/sections/shared/SectionInstagram';

export default {
  components: {
    Layout,
    SectionFeaturedPost,
    SocialSharePost,
    PostContent,
    ListRelatedPosts,
    // SectionInstagram,
  },
  props: {
    // Shared Props from WebsiteSharedProps.php
    sectionInstagram: {
      type: Object,
      required: true,
    },
    blogPost: {
      type: Object,
      required: true,
    },
    socialShareTitle: {
      type: String,
      required: true,
    },
    socialLinks: {
      type: Object,
      required: true,
    },
    listRelatedPosts: {
      type: Object,
      required: true,
    },

  },
};
</script>
